<!--
 * @Author: LUOHM
 * @Date: 2022-01-24 09:58:12
 * @LastEditTime: 2022-10-18 15:49:25
 * @LastEditors: LUOHM
-->
<template>
  <div class="page-container">
    <question class="question" index="01">{{$t("survey.score.q")}}</question>
    <score-box v-model="activatedScore"></score-box>
    <div class="tips">
      <span>{{$t("survey.score.tips.no")}}</span>
      <span>{{$t("survey.score.tips.yes")}}</span>
    </div>
    <next-button @click="onNext" :disabled="activatedScore<0">{{$t("survey.next")}}</next-button>
    <div :style="{position:'fixed',bottom:'20px',left:'50%',transform:'translateX(-50%)',fontSize:'12px'}">
      <a href="https://beian.miit.gov.cn/">蜀ICP备11001597号-19</a>
    </div>
  </div>
</template>

<script>
import ScoreBox from '../../components/ScoreBox'
import Question from '../../components/Question'
import NextButton from '../../components/NextButton'
import utils from '../../utils'
import mixin from './mixin'

export default {
  components: {
    NextButton,
    ScoreBox,
    Question
  },

  mixins: [mixin],

  data(){
    return {
      activatedScore: -1
    }
  },

  methods: {
    onNext() {
      this.$s.setScore(this.activatedScore)
      this.reportData()
      this.$router.push({path:'Reason',query:{page:utils.store.getQueryVariable('page')}})
    },

    reportData() {
      // utils.native.reportEvent({
      //   event_id: "advance_element_action",
      //   element_id: "nps_survey",
      //   sub_element_id:"nps_score",
      //   content_id: this.activatedScore,
      //   action:"next",
      //   page:utils.store.getQueryVariable('page')
      // })
      gio('track', 'advance_element_action',{
        "element_id": "nps_survey",
        "sub_element_id":"nps_score",
        "content_id": this.activatedScore,
        "action":"next",
        "page":utils.store.getQueryVariable('page')
      });
    }
  }
}
</script>

<style lang="stylus" scoped>

.tips
  display flex
  justify-content space-between
  padding 0 38px
  margin-top 20px
  font-size 28px
  font-family 'PingFang-SC-Regular'
  color $dark-text-color
.question
    margin 60px auto 80px

</style>
